import { AlertTriangle, Loader2 } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";
import { useModal } from "@/hooks/use-modal";

interface ConfirmFinishModalProps {
	onConfirm: () => Promise<void>;
	unanswered: number;
}

export function ConfirmFinishModal({
	onConfirm,
	unanswered,
}: ConfirmFinishModalProps) {
	const { closeModal } = useModal();
	const [isPending, setIsPending] = useState(false);

	const handleConfirm = async () => {
		setIsPending(true);
		try {
			await onConfirm();
			closeModal();
		} catch (error) {
			console.error("Erro ao finalizar prova:", error);
			setIsPending(false);
		}
	};

	return (
		<DialogContent className="max-w-md rounded-md p-8">
			<DialogHeader className="space-y-4">
				<div className="size-16 bg-[#fff1f2] rounded-xl flex items-center justify-center text-[#f43f5e] mx-auto">
					<AlertTriangle size={32} />
				</div>
				{unanswered > 0 ? (
					<>
						<DialogTitle className="text-2xl font-bold text-[#0f172a] text-center">
							Atenção, você deixou questões em branco!
						</DialogTitle>
						<DialogDescription className="text-[#64748b] text-center text-base">
							Revise sua prova, existem{" "}
							<strong className="text-[#0f172a]">
								{unanswered}{" "}
								{unanswered === 1
									? "questão não respondida"
									: "questões não respondidas"}
							</strong>
							!
						</DialogDescription>
					</>
				) : (
					<>
						<DialogTitle className="text-2xl font-bold text-[#0f172a] text-center">
							Deseja realmente finalizar a prova?
						</DialogTitle>
						<DialogDescription className="text-[#64748b] text-center text-base">
							Após finalizar, você não poderá mais alterar suas respostas.
							Certifique-se de que revisou tudo o que desejava.
						</DialogDescription>
					</>
				)}
			</DialogHeader>
			<DialogFooter className="flex flex-col-reverse sm:flex-row gap-3 mt-8">
				<Button
					variant="outline"
					onClick={closeModal}
					disabled={isPending}
					className="flex-1 h-14 rounded-md border-[#e2e8f0] text-[#475569] font-bold"
				>
					Voltar para a prova
				</Button>
				<Button
					onClick={handleConfirm}
					disabled={isPending}
					className="flex-1 h-14 rounded-md bg-[#e11d48] hover:bg-[#be123c] text-white font-bold"
				>
					{isPending ? (
						<>
							<Loader2 className="mr-2 h-4 w-4 animate-spin" />
							Finalizando...
						</>
					) : unanswered > 0 ? (
						"Finalizar mesmo assim"
					) : (
						"Finalizar"
					)}
				</Button>
			</DialogFooter>
		</DialogContent>
	);
}
